import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchProducts } from "../../store/reducers/home/apiThunk";

export function useProducts(id = null, allProductList = true, currentProductId = null) {
  const [loading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [count, setCount] = useState(1);
  const [pageDetails, setPageDetails] = useState({});
  const [isViewMoreVisible, setViewMoreVisible] = useState(true);
  const [isError, setIsError] = useState(false);
  const dispatch = useDispatch();
  const productsContainerRef = useRef(null);

  const searchProducts = async (param, pageSize = 12, pageOverride = null) => {
    const pageNo = pageOverride !== null ? pageOverride : count;
    setIsLoading(true);
    try {
      const response = await dispatch(fetchProducts(param + `&page_no=${pageNo}&page_size=${pageSize}`));
      const { status, data, message } = response.payload;

      if (status) {
        setIsError(false);
        if (pageNo === 1) {
          if (currentProductId !== null) {
            setProducts(data?.filter(item => parseInt(item.id) !== parseInt(currentProductId)))
          } else
            setProducts(data)
        }
        else {
          setProducts((prevProducts) => {
            // Remove automatic scroll for infinite scroll compatibility
            // The infinite scroll component will handle visibility
            return [...prevProducts, ...data];
          });
        }
        setPageDetails(response.payload?._meta)
      } else {
        console.error(message);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsError(true);
      if (count > 1)
        setCount((prev) => prev - 1);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id !== null && allProductList) {
      if (pageDetails?.total_pages >= count) {
        searchProducts(id);
      } else if (!pageDetails?.total_pages) {
        searchProducts(id);
      }
      if (pageDetails?.total_pages && (pageDetails?.total_pages === pageDetails?.current_page || pageDetails?.total_pages < count)) {
        setViewMoreVisible(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, count, allProductList]);

  return {
    setCount,
    loading,
    products,
    count,
    pageDetails,
    isViewMoreVisible,
    productsContainerRef,
    isError,
    searchProducts,
    setProducts,
    setIsLoading
  };
}
